import React from 'react'

import { faCheckCircle, faCircle, faLocationCircle } from '@fortawesome/pro-regular-svg-icons'
import { faBan, faSync } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Pill } from '@scoir/pills'
import PropTypes from 'prop-types'

import usePolling from 'routes/application/usePolling'

import { APPLICATION_STATUS } from '../constants'

const useStyles = makeStyles((theme) => ({
  statusContainer: {
    maxWidth: theme.spacing(64),
    height: theme.spacing(10),
    backgroundColor: '#e7f4f7',
  },
  refreshButton: {
    fontSize: theme.typography.pxToRem(15),
  },
  continueButton: {
    width: theme.spacing(64),
  },
  pill: {
    fontSize: theme.typography.pxToRem(14),
    padding: theme.spacing(2),
  },
  refreshIcon: {
    color: theme.palette.primary.main,
  },
}))

const AppStatusRefresher = ({ status, refresh, shouldRefresh, refreshInterval }) => {
  const styles = useStyles()
  const interval = shouldRefresh ? refreshInterval : 0
  usePolling(refresh, interval)
  const getStatusIcon = () => {
    switch (status) {
      case APPLICATION_STATUS.Initiating:
        return (
          <Pill
            color="secondary"
            className={styles.pill}
          >
            <FontAwesomeIcon icon={faCircle} />
            &nbsp;Initiating
          </Pill>
        )
      case APPLICATION_STATUS.Initiated:
        return (
          <Pill
            color="warning"
            className={styles.pill}
          >
            <FontAwesomeIcon icon={faLocationCircle} />
            &nbsp;Initiated
          </Pill>
        )
      case APPLICATION_STATUS.Submitted:
        return (
          <Pill
            color="success"
            className={styles.pill}
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            &nbsp;Submitted
          </Pill>
        )
      default:
        return (
          <Pill
            color="text"
            className={styles.pill}
          >
            <FontAwesomeIcon icon={faBan} />
            &nbsp;No Status
          </Pill>
        )
    }
  }

  return (
    <Box
      className={styles.statusContainer}
      my={3}
      p={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      {getStatusIcon()}
      <FontAwesomeIcon
        icon={faSync}
        spin={shouldRefresh}
        className={styles.refreshIcon}
      />
    </Box>
  )
}

AppStatusRefresher.propTypes = {
  status: PropTypes.string,
  refresh: PropTypes.func.isRequired,
  refreshInterval: PropTypes.number.isRequired,
  shouldRefresh: PropTypes.bool,
}

export default AppStatusRefresher
